import {getCookie} from 'common/util/cookie';

import {reporter} from '../error-reporting';

export interface UserIdentity {
  id: number;
  email: string;
  name: string;
}

/**
 * utf-8 compatible b64 decode
 * see https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
 * NOTE: not exported, if another consumer needs this, move to common/util/base64.ts
 */
function base64Decode(b64Str: string): string {
  return new TextDecoder().decode(Uint8Array.from(window.atob(b64Str), (c) => c.charCodeAt(0)));
}

export function getUserIdentityFromCookie(): UserIdentity | null {
  let userIdentity = null;
  const userCookie = getCookie(`mp_user`);

  // user cookie format is b64(json({id,email,name}))
  if (userCookie) {
    try {
      userIdentity = JSON.parse(base64Decode(userCookie));
    } catch (err) {
      reporter.error(`Failed to parse user cookie: ${userCookie}`, err);
    }
  }

  return userIdentity;
}
